import { render, staticRenderFns } from "./TwoFactorLogin.vue?vue&type=template&id=00c06f66"
import script from "./TwoFactorLogin.vue?vue&type=script&lang=js"
export * from "./TwoFactorLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports